export const inventory = {
  title: 'Készletkezelés',
  subtitle: 'Készletek és készletmozgások nyilvántartása',
  filteredByProduct: 'Szűrve termékre',
  
  tab: {
    stock: 'Készlet',
    movements: 'Készletmozgások',
    documents: 'Dokumentumok'
  },
  
  belowMinimum: 'Minimum alatt',
  aboveMaximum: 'Maximum felett',
  outOfStock: 'Nincs készleten',
  inStock: 'Készleten',
  allWarehouses: 'Összes raktár',
  onlyAvailable: 'Csak elérhető',
  noItemsFound: 'Nem találhatók készlettételek',
  product: 'Termék',
  warehouse: 'Raktár',
  status: 'Állapot',
  quantity: 'Mennyiség',
  reserved: 'Foglalt',
  available: 'Elérhető',
  minimumQuantity: 'Minimum',
  maximumQuantity: 'Maximum',
  
  list: {
    title: 'Készlet',
    empty: 'Nincs készleten termék',
    search: 'Termék keresése',
    filter: 'Szűrők',
    product: 'Termék',
    warehouse: 'Raktár',
    quantity: 'Mennyiség',
    available: 'Elérhető',
    reserved: 'Foglalt',
    unit: 'Egység',
    minQuantity: 'Minimum szint',
    maxQuantity: 'Maximum szint',
    lastUpdated: 'Utolsó frissítés',
    belowMinimum: 'Minimum szint alatt',
    aboveMaximum: 'Maximum szint felett',
    onlyAvailable: 'Csak elérhető készlet'
  },
  
  movements: {
    title: 'Készletmozgások',
    empty: 'Nincsenek készletmozgások',
    search: 'Keresés a készletmozgások között',
    filter: 'Szűrők',
    date: 'Dátum',
    product: 'Termék',
    warehouse: 'Raktár',
    targetWarehouse: 'Célraktár',
    quantity: 'Mennyiség',
    type: 'Mozgás típusa',
    document: 'Dokumentum',
    user: 'Felhasználó',
    note: 'Megjegyzés',
    dateRange: 'Időszak',
    fromDate: 'Kezdő dátum',
    toDate: 'Záró dátum',
    noMovementsFound: 'Nem találhatók készletmozgások',
    allWarehouses: 'Összes raktár',
    newestFirst: 'Legújabbak elöl',
    oldestFirst: 'Legrégebbiek elöl',
    sortNewestFirst: 'Legújabbak elöl',
    sortOldestFirst: 'Legrégebbiek elöl',
    refresh: 'Frissítés'
  },
  
  documentTypes: {
    'Raktári bevét': 'Raktári bevét',
    'Raktári kiadás': 'Raktári kiadás',
    'Raktári átmozgatás': 'Raktári átmozgatás',
    'Korrekció': 'Korrekció',
    'Leltár': 'Leltár',
    'Foglalás': 'Foglalás',
    'Foglalás feloldás': 'Foglalás feloldás',
    'Raktárközi átadás': 'Raktárközi átadás',
    'Számla': 'Számla',
    'Bejövõ számla': 'Bejövő számla',
    'RECEIPT': 'Bevételezési bizonylat',
    'TRANSFER': 'Átmozgatási bizonylat'
  },
  
  movementTypes: {
    STOCK_IN: 'Bevételezés',
    STOCK_OUT: 'Kiadás',
    STOCK_TRANSFER: 'Átmozgatás',
    STOCK_ADJUSTMENT: 'Korrekció',
    STOCK_INVENTORY: 'Leltár',
    STOCK_RESERVATION: 'Foglalás',
    STOCK_RESERVATION_RELEASE: 'Foglalás feloldása',
    BEVÉTELEZÉS: 'Bevételezés',
    KIADÁS: 'Kiadás',
    ÁTMOZGATÁS: 'Átmozgatás',
    KORREKCIÓ: 'Korrekció',
    ISMERETLEN: 'Ismeretlen',
    stockInShort: 'Bevét',
    stockOutShort: 'Kiadás',
    transferShort: 'Átraktár',
    adjustmentShort: 'Korrekció',
    inventoryShort: 'Leltár',
    reservationShort: 'Foglalás',
    releaseShort: 'Felszab'
  },
  
  actions: {
    stockIn: 'Készlet bevételezés',
    stockOut: 'Kiadás',
    transfer: 'Raktárak közötti átmozgatás',
    adjustment: 'Korrekció',
    inventory: 'Leltározás',
    reservation: 'Foglalás',
    releaseReservation: 'Foglalás feloldása'
  },
  
  form: {
    title: {
      stockIn: 'Új bevételezés',
      stockOut: 'Új kiadás',
      transfer: 'Raktári átmozgatás',
      adjustment: 'Készletkorrekció',
      inventory: 'Leltár rögzítése',
      reservation: 'Készlet foglalása',
      releaseReservation: 'Foglalás feloldása'
    },
    product: 'Termék',
    warehouse: 'Raktár',
    targetWarehouse: 'Célraktár',
    quantity: 'Mennyiség',
    document: 'Kapcsolódó dokumentum',
    documentNumber: 'Dokumentum száma',
    note: 'Megjegyzés',
    lotNumber: 'Gyártási szám',
    expiryDate: 'Lejárati dátum',
    serialNumber: 'Sorozatszám',
    currentStock: 'Jelenlegi készlet',
    location: 'Raktárhely',
    date: 'Dátum',
    selectProduct: 'Válasszon terméket',
    selectWarehouse: 'Válasszon raktárt'
  },
  
  success: {
    stockIn: 'A bevételezés sikeresen rögzítve',
    stockOut: 'A kiadás sikeresen rögzítve',
    transfer: 'Az átmozgatás sikeresen rögzítve',
    adjustment: 'A korrekció sikeresen rögzítve',
    inventory: 'A leltár sikeresen rögzítve',
    reservation: 'A foglalás sikeresen rögzítve',
    releaseReservation: 'A foglalás feloldása sikeresen rögzítve'
  },
  
  error: {
    insufficientStock: 'Nincs elegendő készlet a művelethez',
    productNotFound: 'A termék nem található',
    warehouseNotFound: 'A raktár nem található',
    generic: 'Hiba történt a készletművelet során'
  },
  
  report: {
    title: 'Készletjelentés',
    totalQuantity: 'Teljes mennyiség',
    availableQuantity: 'Elérhető mennyiség',
    reservedQuantity: 'Foglalt mennyiség',
    warehouseDetails: 'Raktárankénti bontás',
    export: 'Exportálás',
    filter: 'Szűrés',
    product: 'Termék',
    warehouse: 'Raktár'
  }
}; 